import React from 'react';
import ReactDOM from 'react-dom/client';
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

import './index.css';
import "./fontawesome.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import TurnstileGuard from './components/CloudGuard';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <TurnstileGuard siteKey={"0x4AAAAAACMOSz__HjEFZTSk"}>
      <App />
    </TurnstileGuard>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
